<template>
    <div class="ttl-editor">
        <h4 style="margin-bottom: 8px;">
            <a-icon type="clock-circle" style="margin-right: 8px;" />
            {{ $t('whatsapp_business_api.messageTtlOptional') }}
        </h4>
        <p class="ttl-description">
            {{ getTtlDescription }}
        </p>
        
        <div class="ttl-input-row">
            <a-select
                :value="value"
                @change="handleChange"
                style="width: 100%"
                :placeholder="$t('whatsapp_business_api.selectTtlPlaceholder')"
                allowClear
            >
                <a-select-option
                    v-for="option in getTtlOptions"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.label }}
                </a-select-option>
            </a-select>
        </div>
        
        <div class="ttl-info">
            <a-icon type="info-circle" style="margin-right: 4px; color: #1890ff;" />
            <span>{{ getTtlInfoText }}</span>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "TTLEditor",
    props: {
        value: { type: Number, default: null },
        category: { type: String, required: true },
    },
    computed: {
        getTtlDescription() {
            const keyMap = {
                MARKETING: "whatsapp_business_api.ttlDescMarketing",
                UTILITY: "whatsapp_business_api.ttlDescUtility",
                AUTHENTICATION: "whatsapp_business_api.ttlDescAuthentication",
            };
            var key = keyMap[this.category];
            return key ? this.$t(key) : "";
        },
        getTtlOptions() {
            var t = function (key) { return this.$t("whatsapp_business_api." + key); }.bind(this);
            const options = {
                MARKETING: [
                    { value: 43200, label: t("ttlOption12Hours") },
                    { value: 86400, label: t("ttlOption1Day") },
                    { value: 259200, label: t("ttlOption3Days") },
                    { value: 604800, label: t("ttlOption7Days") },
                    { value: 1296000, label: t("ttlOption15Days") },
                    { value: 2592000, label: t("ttlOption30Days") },
                ],
                UTILITY: [
                    { value: 30, label: t("ttlOption30Seconds") },
                    { value: 60, label: t("ttlOption1Minute") },
                    { value: 300, label: t("ttlOption5Minutes") },
                    { value: 600, label: t("ttlOption10Minutes") },
                    { value: 1800, label: t("ttlOption30Minutes") },
                    { value: 3600, label: t("ttlOption1Hour") },
                    { value: 7200, label: t("ttlOption2Hours") },
                    { value: 14400, label: t("ttlOption4Hours") },
                    { value: 21600, label: t("ttlOption6Hours") },
                    { value: 43200, label: t("ttlOption12Hours") },
                    { value: -1, label: t("ttlOption30DaysSpecial") },
                ],
                AUTHENTICATION: [
                    { value: 30, label: t("ttlOption30Seconds") },
                    { value: 60, label: t("ttlOption1Minute") },
                    { value: 120, label: t("ttlOption2Minutes") },
                    { value: 180, label: t("ttlOption3Minutes") },
                    { value: 300, label: t("ttlOption5Minutes") },
                    { value: 600, label: t("ttlOption10Minutes") },
                    { value: 900, label: t("ttlOption15Minutes") },
                    { value: -1, label: t("ttlOption30DaysSpecial") },
                ],
            };
            return options[this.category] || [];
        },
        getTtlInfoText() {
            const keyMap = {
                MARKETING: "whatsapp_business_api.ttlInfoMarketing",
                UTILITY: "whatsapp_business_api.ttlInfoUtility",
                AUTHENTICATION: "whatsapp_business_api.ttlInfoAuthentication",
            };
            var key = keyMap[this.category];
            return key ? this.$t(key) : "";
        },
    },
    methods: {
        handleChange(value) {
            this.$emit('update', value);
        },
    },
});
</script>

<style scoped lang="scss">
.ttl-editor {
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 8px;
    padding: 16px;
    margin-top: 16px;

    h4 {
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        display: flex;
        align-items: center;
    }

    .ttl-description {
        margin: 8px 0 16px 0;
        font-size: 13px;
        color: #666;
        line-height: 1.5;
    }

    .ttl-input-row {
        margin-bottom: 12px;
    }

    .ttl-info {
        display: flex;
        align-items: flex-start;
        gap: 4px;
        font-size: 12px;
        color: #666;
        line-height: 1.6;
        padding: 8px;
        background: #fff;
        border-radius: 4px;
    }
}
</style>
